/**
 * Members Services Module
 * Exports all member management services and factory functions
 */
// Service exports (export classes only, not internal types)
export { MemberService } from './MemberService';
export { FamilyService } from './FamilyService';
export { MemberTypeService } from './MemberTypeService';
export { MaritalStatusService } from './MaritalStatusService';
export { MemberAddressService } from './MemberAddressService';
export { MemberLocationService } from './MemberLocationService';
export { AllergyService } from './AllergyService';
export { DisabilityService } from './DisabilityService';
export { RelationshipService } from './RelationshipService';
export { MemberMeService } from './MemberMeService';
// Service imports for factory
import { MemberService } from './MemberService';
import { FamilyService } from './FamilyService';
import { MemberTypeService } from './MemberTypeService';
import { MaritalStatusService } from './MaritalStatusService';
import { MemberAddressService } from './MemberAddressService';
import { MemberLocationService } from './MemberLocationService';
import { AllergyService } from './AllergyService';
import { DisabilityService } from './DisabilityService';
import { RelationshipService } from './RelationshipService';
import { MemberMeService } from './MemberMeService';
/**
 * Create all member services with shared configuration
 * @param http - HTTP client instance
 * @param config - Service configuration (servicePath, endpoints)
 * @returns Object containing all member service instances
 */
export function createMemberServices(http, config) {
    return {
        member: new MemberService(http, config),
        family: new FamilyService(http, config),
        memberType: new MemberTypeService(http, config),
        maritalStatus: new MaritalStatusService(http, config),
        memberAddress: new MemberAddressService(http, config),
        memberLocation: new MemberLocationService(http, config),
        allergy: new AllergyService(http, config),
        disability: new DisabilityService(http, config),
        relationship: new RelationshipService(http, config),
        memberMe: new MemberMeService(http, config),
    };
}
//# sourceMappingURL=index.js.map